"use strict";
export default function copy(text) {
  var 
    mark,
    success = false;
  try {
    mark = document.createElement("textarea");
    mark.style.position = 'fixed';
    mark.style.top = 0;
    mark.style.left = 0;
  
    mark.style.width = '2em';
    mark.style.height = '2em';
  
    mark.style.padding = 0;
  
    mark.style.border = 'none';
    mark.style.outline = 'none';
    mark.style.boxShadow = 'none';
    mark.style.backgroundColor = "transparent";
    mark.value = text;

    document.body.appendChild(mark);
    mark.focus();
    mark.select();

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    console.error("unable to copy using execCommand: ", err);
    console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData("text", text);
      success = true;
    } catch (err) {
      console.error("unable to copy using clipboardData: ", err);
      console.error("falling back to prompt");
    }
  } finally {
    if (mark) {
      document.body.removeChild(mark);
    }
  }

  return success;
}



// WEBPACK FOOTER //
// ./src/components/utils/copyClipboard.js